// Centralise drop down list values some place
export const yesNoOptions = [
  { key: 'yes', label: 'Yes' },
  { key: 'no', label: 'No' },
]

export const repaymentTypes = [
  { key: 'Fixed', label: 'Fixed' },
  { key: 'Basic Variable', label: 'Floating' },
  { key: 'Split', label: 'Fixed and Floating Combo' },
]

export const frequencyFullListOptions = [
  { key: 'Daily', label: 'Daily' },
  { key: 'Fortnightly', label: 'Fortnightly' },
  { key: 'HalfYearly', label: 'Half Yearly' },
  { key: 'Monthly', label: 'Monthly' },
  { key: 'OneOff', label: 'One Off' },
  { key: 'Quarterly', label: 'Quarterly' },
  { key: 'Seasonal', label: 'Seasonal' },
  { key: 'Weekly', label: 'Weekly' },
  { key: 'Yearly', label: 'Yearly' },
]

// These options used for Other Income as service.lending uses this not the full list.
// If the full list is used, with option like Half Year, the service lending LIXI service will fail on create.
export const frequencyShortListOptions = [
  { key: 'Fortnightly', label: 'Fortnightly' },
  { key: 'Monthly', label: 'Monthly' },
  { key: 'Weekly', label: 'Weekly' },
  { key: 'Yearly', label: 'Yearly' },
]

export const titlesOptions = [
  { key: 'Mr', label: 'Mr' },
  { key: 'Mrs', label: 'Mrs' },
  { key: 'Ms', label: 'Ms' },
  { key: 'Miss', label: 'Miss' },
  { key: 'Master', label: 'Master' },
  { key: 'Dr', label: 'Dr' },
]

export const maritalStatusOptions = [
  { key: 'Single', label: 'Single' },
  { key: 'Married', label: 'Married' },
  { key: 'DeFacto', label: 'DeFacto' },
  { key: 'Separated', label: 'Separated' },
  { key: 'Divorced', label: 'Divorced' },
  { key: 'Widowed', label: 'Widowed' },
]

export const gendersOptions = [
  { key: 'Male', label: 'Male' },
  { key: 'Female', label: 'Female' },
  { key: 'Undisclosed', label: 'Undisclosed' },
]

export const residencyStatusOptions = [
  { key: 'Permanently in New Zealand', label: 'Citizen' },
  { key: 'Non Resident', label: 'Non Resident' },
  { key: 'Temporarily in New Zealand', label: 'Temporary Resident' },
]

export const trustStructureListOptions = [
  { key: 'discretionary', label: 'Discretionary' },
  { key: 'fixed', label: 'Fixed' },
  { Key: 'hybrid', label: 'Hybrid' },
  { Key: 'simple', label: 'Simple' },
  { key: 'unit', label: 'Unit' },
]

export const countryOptions = [
  {
    name: 'New Zealand',
    dialcode: '+64',
    code: 'NZ',
  },
  {
    name: 'Australia',
    dialcode: '+61',
    code: 'AU',
  },
  {
    name: 'Afghanistan',
    dialcode: '+93',
    code: 'AF',
  },
  {
    name: 'Aland Islands',
    dialcode: '+358',
    code: 'AX',
  },
  {
    name: 'Albania',
    dialcode: '+355',
    code: 'AL',
  },
  {
    name: 'Algeria',
    dialcode: '+213',
    code: 'DZ',
  },
  {
    name: 'AmericanSamoa',
    dialcode: '+1684',
    code: 'AS',
  },
  {
    name: 'Andorra',
    dialcode: '+376',
    code: 'AD',
  },
  {
    name: 'Angola',
    dialcode: '+244',
    code: 'AO',
  },
  {
    name: 'Anguilla',
    dialcode: '+1264',
    code: 'AI',
  },
  {
    name: 'Antarctica',
    dialcode: '+672',
    code: 'AQ',
  },
  {
    name: 'Antigua and Barbuda',
    dialcode: '+1268',
    code: 'AG',
  },
  {
    name: 'Argentina',
    dialcode: '+54',
    code: 'AR',
  },
  {
    name: 'Armenia',
    dialcode: '+374',
    code: 'AM',
  },
  {
    name: 'Aruba',
    dialcode: '+297',
    code: 'AW',
  },
  {
    name: 'Austria',
    dialcode: '+43',
    code: 'AT',
  },
  {
    name: 'Azerbaijan',
    dialcode: '+994',
    code: 'AZ',
  },
  {
    name: 'Bahamas',
    dialcode: '+1242',
    code: 'BS',
  },
  {
    name: 'Bahrain',
    dialcode: '+973',
    code: 'BH',
  },
  {
    name: 'Bangladesh',
    dialcode: '+880',
    code: 'BD',
  },
  {
    name: 'Barbados',
    dialcode: '+1246',
    code: 'BB',
  },
  {
    name: 'Belarus',
    dialcode: '+375',
    code: 'BY',
  },
  {
    name: 'Belgium',
    dialcode: '+32',
    code: 'BE',
  },
  {
    name: 'Belize',
    dialcode: '+501',
    code: 'BZ',
  },
  {
    name: 'Benin',
    dialcode: '+229',
    code: 'BJ',
  },
  {
    name: 'Bermuda',
    dialcode: '+1441',
    code: 'BM',
  },
  {
    name: 'Bhutan',
    dialcode: '+975',
    code: 'BT',
  },
  {
    name: 'Bolivia, Plurinational State of',
    dialcode: '+591',
    code: 'BO',
  },
  {
    name: 'Bosnia and Herzegovina',
    dialcode: '+387',
    code: 'BA',
  },
  {
    name: 'Botswana',
    dialcode: '+267',
    code: 'BW',
  },
  {
    name: 'Brazil',
    dialcode: '+55',
    code: 'BR',
  },
  {
    name: 'British Indian Ocean Territory',
    dialcode: '+246',
    code: 'IO',
  },
  {
    name: 'Brunei Darussalam',
    dialcode: '+673',
    code: 'BN',
  },
  {
    name: 'Bulgaria',
    dialcode: '+359',
    code: 'BG',
  },
  {
    name: 'Burkina Faso',
    dialcode: '+226',
    code: 'BF',
  },
  {
    name: 'Burundi',
    dialcode: '+257',
    code: 'BI',
  },
  {
    name: 'Cambodia',
    dialcode: '+855',
    code: 'KH',
  },
  {
    name: 'Cameroon',
    dialcode: '+237',
    code: 'CM',
  },
  {
    name: 'Canada',
    dialcode: '+1',
    code: 'CA',
  },
  {
    name: 'Cape Verde',
    dialcode: '+238',
    code: 'CV',
  },
  {
    name: 'Cayman Islands',
    dialcode: '+ 345',
    code: 'KY',
  },
  {
    name: 'Central African Republic',
    dialcode: '+236',
    code: 'CF',
  },
  {
    name: 'Chad',
    dialcode: '+235',
    code: 'TD',
  },
  {
    name: 'Chile',
    dialcode: '+56',
    code: 'CL',
  },
  {
    name: 'China',
    dialcode: '+86',
    code: 'CN',
  },
  {
    name: 'Christmas Island',
    dialcode: '+61',
    code: 'CX',
  },
  {
    name: 'Cocos (Keeling) Islands',
    dialcode: '+61',
    code: 'CC',
  },
  {
    name: 'Colombia',
    dialcode: '+57',
    code: 'CO',
  },
  {
    name: 'Comoros',
    dialcode: '+269',
    code: 'KM',
  },
  {
    name: 'Congo',
    dialcode: '+242',
    code: 'CG',
  },
  {
    name: 'Congo, The Democratic Republic of the Congo',
    dialcode: '+243',
    code: 'CD',
  },
  {
    name: 'Cook Islands',
    dialcode: '+682',
    code: 'CK',
  },
  {
    name: 'Costa Rica',
    dialcode: '+506',
    code: 'CR',
  },
  {
    name: "Cote d'Ivoire",
    dialcode: '+225',
    code: 'CI',
  },
  {
    name: 'Croatia',
    dialcode: '+385',
    code: 'HR',
  },
  {
    name: 'Cuba',
    dialcode: '+53',
    code: 'CU',
  },
  {
    name: 'Cyprus',
    dialcode: '+357',
    code: 'CY',
  },
  {
    name: 'Czech Republic',
    dialcode: '+420',
    code: 'CZ',
  },
  {
    name: 'Denmark',
    dialcode: '+45',
    code: 'DK',
  },
  {
    name: 'Djibouti',
    dialcode: '+253',
    code: 'DJ',
  },
  {
    name: 'Dominica',
    dialcode: '+1767',
    code: 'DM',
  },
  {
    name: 'Dominican Republic',
    dialcode: '+1849',
    code: 'DO',
  },
  {
    name: 'Ecuador',
    dialcode: '+593',
    code: 'EC',
  },
  {
    name: 'Egypt',
    dialcode: '+20',
    code: 'EG',
  },
  {
    name: 'El Salvador',
    dialcode: '+503',
    code: 'SV',
  },
  {
    name: 'Equatorial Guinea',
    dialcode: '+240',
    code: 'GQ',
  },
  {
    name: 'Eritrea',
    dialcode: '+291',
    code: 'ER',
  },
  {
    name: 'Estonia',
    dialcode: '+372',
    code: 'EE',
  },
  {
    name: 'Ethiopia',
    dialcode: '+251',
    code: 'ET',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    dialcode: '+500',
    code: 'FK',
  },
  {
    name: 'Faroe Islands',
    dialcode: '+298',
    code: 'FO',
  },
  {
    name: 'Fiji',
    dialcode: '+679',
    code: 'FJ',
  },
  {
    name: 'Finland',
    dialcode: '+358',
    code: 'FI',
  },
  {
    name: 'France',
    dialcode: '+33',
    code: 'FR',
  },
  {
    name: 'French Guiana',
    dialcode: '+594',
    code: 'GF',
  },
  {
    name: 'French Polynesia',
    dialcode: '+689',
    code: 'PF',
  },
  {
    name: 'Gabon',
    dialcode: '+241',
    code: 'GA',
  },
  {
    name: 'Gambia',
    dialcode: '+220',
    code: 'GM',
  },
  {
    name: 'Georgia',
    dialcode: '+995',
    code: 'GE',
  },
  {
    name: 'Germany',
    dialcode: '+49',
    code: 'DE',
  },
  {
    name: 'Ghana',
    dialcode: '+233',
    code: 'GH',
  },
  {
    name: 'Gibraltar',
    dialcode: '+350',
    code: 'GI',
  },
  {
    name: 'Greece',
    dialcode: '+30',
    code: 'GR',
  },
  {
    name: 'Greenland',
    dialcode: '+299',
    code: 'GL',
  },
  {
    name: 'Grenada',
    dialcode: '+1473',
    code: 'GD',
  },
  {
    name: 'Guadeloupe',
    dialcode: '+590',
    code: 'GP',
  },
  {
    name: 'Guam',
    dialcode: '+1671',
    code: 'GU',
  },
  {
    name: 'Guatemala',
    dialcode: '+502',
    code: 'GT',
  },
  {
    name: 'Guernsey',
    dialcode: '+44',
    code: 'GG',
  },
  {
    name: 'Guinea',
    dialcode: '+224',
    code: 'GN',
  },
  {
    name: 'Guinea-Bissau',
    dialcode: '+245',
    code: 'GW',
  },
  {
    name: 'Guyana',
    dialcode: '+595',
    code: 'GY',
  },
  {
    name: 'Haiti',
    dialcode: '+509',
    code: 'HT',
  },
  {
    name: 'Holy See (Vatican City State)',
    dialcode: '+379',
    code: 'VA',
  },
  {
    name: 'Honduras',
    dialcode: '+504',
    code: 'HN',
  },
  {
    name: 'Hong Kong',
    dialcode: '+852',
    code: 'HK',
  },
  {
    name: 'Hungary',
    dialcode: '+36',
    code: 'HU',
  },
  {
    name: 'Iceland',
    dialcode: '+354',
    code: 'IS',
  },
  {
    name: 'India',
    dialcode: '+91',
    code: 'IN',
  },
  {
    name: 'Indonesia',
    dialcode: '+62',
    code: 'ID',
  },
  {
    name: 'Iran, Islamic Republic of Persian Gulf',
    dialcode: '+98',
    code: 'IR',
  },
  {
    name: 'Iraq',
    dialcode: '+964',
    code: 'IQ',
  },
  {
    name: 'Ireland',
    dialcode: '+353',
    code: 'IE',
  },
  {
    name: 'Isle of Man',
    dialcode: '+44',
    code: 'IM',
  },
  {
    name: 'Israel',
    dialcode: '+972',
    code: 'IL',
  },
  {
    name: 'Italy',
    dialcode: '+39',
    code: 'IT',
  },
  {
    name: 'Jamaica',
    dialcode: '+1876',
    code: 'JM',
  },
  {
    name: 'Japan',
    dialcode: '+81',
    code: 'JP',
  },
  {
    name: 'Jersey',
    dialcode: '+44',
    code: 'JE',
  },
  {
    name: 'Jordan',
    dialcode: '+962',
    code: 'JO',
  },
  {
    name: 'Kazakhstan',
    dialcode: '+77',
    code: 'KZ',
  },
  {
    name: 'Kenya',
    dialcode: '+254',
    code: 'KE',
  },
  {
    name: 'Kiribati',
    dialcode: '+686',
    code: 'KI',
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    dialcode: '+850',
    code: 'KP',
  },
  {
    name: 'Korea, Republic of South Korea',
    dialcode: '+82',
    code: 'KR',
  },
  {
    name: 'Kuwait',
    dialcode: '+965',
    code: 'KW',
  },
  {
    name: 'Kyrgyzstan',
    dialcode: '+996',
    code: 'KG',
  },
  {
    name: 'Laos',
    dialcode: '+856',
    code: 'LA',
  },
  {
    name: 'Latvia',
    dialcode: '+371',
    code: 'LV',
  },
  {
    name: 'Lebanon',
    dialcode: '+961',
    code: 'LB',
  },
  {
    name: 'Lesotho',
    dialcode: '+266',
    code: 'LS',
  },
  {
    name: 'Liberia',
    dialcode: '+231',
    code: 'LR',
  },
  {
    name: 'Libyan Arab Jamahiriya',
    dialcode: '+218',
    code: 'LY',
  },
  {
    name: 'Liechtenstein',
    dialcode: '+423',
    code: 'LI',
  },
  {
    name: 'Lithuania',
    dialcode: '+370',
    code: 'LT',
  },
  {
    name: 'Luxembourg',
    dialcode: '+352',
    code: 'LU',
  },
  {
    name: 'Macao',
    dialcode: '+853',
    code: 'MO',
  },
  {
    name: 'Macedonia',
    dialcode: '+389',
    code: 'MK',
  },
  {
    name: 'Madagascar',
    dialcode: '+261',
    code: 'MG',
  },
  {
    name: 'Malawi',
    dialcode: '+265',
    code: 'MW',
  },
  {
    name: 'Malaysia',
    dialcode: '+60',
    code: 'MY',
  },
  {
    name: 'Maldives',
    dialcode: '+960',
    code: 'MV',
  },
  {
    name: 'Mali',
    dialcode: '+223',
    code: 'ML',
  },
  {
    name: 'Malta',
    dialcode: '+356',
    code: 'MT',
  },
  {
    name: 'Marshall Islands',
    dialcode: '+692',
    code: 'MH',
  },
  {
    name: 'Martinique',
    dialcode: '+596',
    code: 'MQ',
  },
  {
    name: 'Mauritania',
    dialcode: '+222',
    code: 'MR',
  },
  {
    name: 'Mauritius',
    dialcode: '+230',
    code: 'MU',
  },
  {
    name: 'Mayotte',
    dialcode: '+262',
    code: 'YT',
  },
  {
    name: 'Mexico',
    dialcode: '+52',
    code: 'MX',
  },
  {
    name: 'Micronesia, Federated States of Micronesia',
    dialcode: '+691',
    code: 'FM',
  },
  {
    name: 'Moldova',
    dialcode: '+373',
    code: 'MD',
  },
  {
    name: 'Monaco',
    dialcode: '+377',
    code: 'MC',
  },
  {
    name: 'Mongolia',
    dialcode: '+976',
    code: 'MN',
  },
  {
    name: 'Montenegro',
    dialcode: '+382',
    code: 'ME',
  },
  {
    name: 'Montserrat',
    dialcode: '+1664',
    code: 'MS',
  },
  {
    name: 'Morocco',
    dialcode: '+212',
    code: 'MA',
  },
  {
    name: 'Mozambique',
    dialcode: '+258',
    code: 'MZ',
  },
  {
    name: 'Myanmar',
    dialcode: '+95',
    code: 'MM',
  },
  {
    name: 'Namibia',
    dialcode: '+264',
    code: 'NA',
  },
  {
    name: 'Nauru',
    dialcode: '+674',
    code: 'NR',
  },
  {
    name: 'Nepal',
    dialcode: '+977',
    code: 'NP',
  },
  {
    name: 'Netherlands',
    dialcode: '+31',
    code: 'NL',
  },
  {
    name: 'Netherlands Antilles',
    dialcode: '+599',
    code: 'AN',
  },
  {
    name: 'New Caledonia',
    dialcode: '+687',
    code: 'NC',
  },
  {
    name: 'Nicaragua',
    dialcode: '+505',
    code: 'NI',
  },
  {
    name: 'Niger',
    dialcode: '+227',
    code: 'NE',
  },
  {
    name: 'Nigeria',
    dialcode: '+234',
    code: 'NG',
  },
  {
    name: 'Niue',
    dialcode: '+683',
    code: 'NU',
  },
  {
    name: 'Norfolk Island',
    dialcode: '+672',
    code: 'NF',
  },
  {
    name: 'Northern Mariana Islands',
    dialcode: '+1670',
    code: 'MP',
  },
  {
    name: 'Norway',
    dialcode: '+47',
    code: 'NO',
  },
  {
    name: 'Oman',
    dialcode: '+968',
    code: 'OM',
  },
  {
    name: 'Pakistan',
    dialcode: '+92',
    code: 'PK',
  },
  {
    name: 'Palau',
    dialcode: '+680',
    code: 'PW',
  },
  {
    name: 'Palestinian Territory, Occupied',
    dialcode: '+970',
    code: 'PS',
  },
  {
    name: 'Panama',
    dialcode: '+507',
    code: 'PA',
  },
  {
    name: 'Papua New Guinea',
    dialcode: '+675',
    code: 'PG',
  },
  {
    name: 'Paraguay',
    dialcode: '+595',
    code: 'PY',
  },
  {
    name: 'Peru',
    dialcode: '+51',
    code: 'PE',
  },
  {
    name: 'Philippines',
    dialcode: '+63',
    code: 'PH',
  },
  {
    name: 'Pitcairn',
    dialcode: '+872',
    code: 'PN',
  },
  {
    name: 'Poland',
    dialcode: '+48',
    code: 'PL',
  },
  {
    name: 'Portugal',
    dialcode: '+351',
    code: 'PT',
  },
  {
    name: 'Puerto Rico',
    dialcode: '+1939',
    code: 'PR',
  },
  {
    name: 'Qatar',
    dialcode: '+974',
    code: 'QA',
  },
  {
    name: 'Romania',
    dialcode: '+40',
    code: 'RO',
  },
  {
    name: 'Russia',
    dialcode: '+7',
    code: 'RU',
  },
  {
    name: 'Rwanda',
    dialcode: '+250',
    code: 'RW',
  },
  {
    name: 'Reunion',
    dialcode: '+262',
    code: 'RE',
  },
  {
    name: 'Saint Barthelemy',
    dialcode: '+590',
    code: 'BL',
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    dialcode: '+290',
    code: 'SH',
  },
  {
    name: 'Saint Kitts and Nevis',
    dialcode: '+1869',
    code: 'KN',
  },
  {
    name: 'Saint Lucia',
    dialcode: '+1758',
    code: 'LC',
  },
  {
    name: 'Saint Martin',
    dialcode: '+590',
    code: 'MF',
  },
  {
    name: 'Saint Pierre and Miquelon',
    dialcode: '+508',
    code: 'PM',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    dialcode: '+1784',
    code: 'VC',
  },
  {
    name: 'Samoa',
    dialcode: '+685',
    code: 'WS',
  },
  {
    name: 'San Marino',
    dialcode: '+378',
    code: 'SM',
  },
  {
    name: 'Sao Tome and Principe',
    dialcode: '+239',
    code: 'ST',
  },
  {
    name: 'Saudi Arabia',
    dialcode: '+966',
    code: 'SA',
  },
  {
    name: 'Senegal',
    dialcode: '+221',
    code: 'SN',
  },
  {
    name: 'Serbia',
    dialcode: '+381',
    code: 'RS',
  },
  {
    name: 'Seychelles',
    dialcode: '+248',
    code: 'SC',
  },
  {
    name: 'Sierra Leone',
    dialcode: '+232',
    code: 'SL',
  },
  {
    name: 'Singapore',
    dialcode: '+65',
    code: 'SG',
  },
  {
    name: 'Slovakia',
    dialcode: '+421',
    code: 'SK',
  },
  {
    name: 'Slovenia',
    dialcode: '+386',
    code: 'SI',
  },
  {
    name: 'Solomon Islands',
    dialcode: '+677',
    code: 'SB',
  },
  {
    name: 'Somalia',
    dialcode: '+252',
    code: 'SO',
  },
  {
    name: 'South Africa',
    dialcode: '+27',
    code: 'ZA',
  },
  {
    name: 'South Sudan',
    dialcode: '+211',
    code: 'SS',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    dialcode: '+500',
    code: 'GS',
  },
  {
    name: 'Spain',
    dialcode: '+34',
    code: 'ES',
  },
  {
    name: 'Sri Lanka',
    dialcode: '+94',
    code: 'LK',
  },
  {
    name: 'Sudan',
    dialcode: '+249',
    code: 'SD',
  },
  {
    name: 'Suriname',
    dialcode: '+597',
    code: 'SR',
  },
  {
    name: 'Svalbard and Jan Mayen',
    dialcode: '+47',
    code: 'SJ',
  },
  {
    name: 'Swaziland',
    dialcode: '+268',
    code: 'SZ',
  },
  {
    name: 'Sweden',
    dialcode: '+46',
    code: 'SE',
  },
  {
    name: 'Switzerland',
    dialcode: '+41',
    code: 'CH',
  },
  {
    name: 'Syrian Arab Republic',
    dialcode: '+963',
    code: 'SY',
  },
  {
    name: 'Taiwan',
    dialcode: '+886',
    code: 'TW',
  },
  {
    name: 'Tajikistan',
    dialcode: '+992',
    code: 'TJ',
  },
  {
    name: 'Tanzania, United Republic of Tanzania',
    dialcode: '+255',
    code: 'TZ',
  },
  {
    name: 'Thailand',
    dialcode: '+66',
    code: 'TH',
  },
  {
    name: 'Timor-Leste',
    dialcode: '+670',
    code: 'TL',
  },
  {
    name: 'Togo',
    dialcode: '+228',
    code: 'TG',
  },
  {
    name: 'Tokelau',
    dialcode: '+690',
    code: 'TK',
  },
  {
    name: 'Tonga',
    dialcode: '+676',
    code: 'TO',
  },
  {
    name: 'Trinidad and Tobago',
    dialcode: '+1868',
    code: 'TT',
  },
  {
    name: 'Tunisia',
    dialcode: '+216',
    code: 'TN',
  },
  {
    name: 'Turkey',
    dialcode: '+90',
    code: 'TR',
  },
  {
    name: 'Turkmenistan',
    dialcode: '+993',
    code: 'TM',
  },
  {
    name: 'Turks and Caicos Islands',
    dialcode: '+1649',
    code: 'TC',
  },
  {
    name: 'Tuvalu',
    dialcode: '+688',
    code: 'TV',
  },
  {
    name: 'Uganda',
    dialcode: '+256',
    code: 'UG',
  },
  {
    name: 'Ukraine',
    dialcode: '+380',
    code: 'UA',
  },
  {
    name: 'United Arab Emirates',
    dialcode: '+971',
    code: 'AE',
  },
  {
    name: 'United Kingdom',
    dialcode: '+44',
    code: 'GB',
  },
  {
    name: 'United States',
    dialcode: '+1',
    code: 'US',
  },
  {
    name: 'Uruguay',
    dialcode: '+598',
    code: 'UY',
  },
  {
    name: 'Uzbekistan',
    dialcode: '+998',
    code: 'UZ',
  },
  {
    name: 'Vanuatu',
    dialcode: '+678',
    code: 'VU',
  },
  {
    name: 'Venezuela, Bolivarian Republic of Venezuela',
    dialcode: '+58',
    code: 'VE',
  },
  {
    name: 'Vietnam',
    dialcode: '+84',
    code: 'VN',
  },
  {
    name: 'Virgin Islands, British',
    dialcode: '+1284',
    code: 'VG',
  },
  {
    name: 'Virgin Islands, U.S.',
    dialcode: '+1340',
    code: 'VI',
  },
  {
    name: 'Wallis and Futuna',
    dialcode: '+681',
    code: 'WF',
  },
  {
    name: 'Yemen',
    dialcode: '+967',
    code: 'YE',
  },
  {
    name: 'Zambia',
    dialcode: '+260',
    code: 'ZM',
  },
  {
    name: 'Zimbabwe',
    dialcode: '+263',
    code: 'ZW',
  },
]
